
// login information
global.ENCODE_DECODE = "EASYBUY093278659287387542";
global.LOGIN_TITTLE = "EasyBuy Admin";
global.LOGIN_SUB_TITTLE = "Inicia tu sesión"
global.LOGIN_EMAIL_TXT = "usuario";
global.LOGIN_PASSWORD_TXT = "Contraseña";
global.LOGIN_BUTTON = "Iniciar Sesión";
global.LOGIN_FORGOT_PASSSWORD = "¿Olvidó su contraseña?";
global.LOGIN_NEW_REGISTER = "Registrar nuevo usuario";
global.LOGIN_FA_EMAIL = "fas fa-envelope";
global.LOGIN_FA_PASS = "fas fa-lock";
global.LOGIN_REMEMBER = "Recordar";
global.VERTICAL = "top";
global.HORIZONTA = "right";
global.DELAY = 1000
global.IMGPATH = '../../img/modulos/'

//gloval var
global.MENU = [];

// Dasboard information
global.FOOTER = "Cabecera"

// establishment information
global.ETITLE = "Establecimientos"
global.STITLE = "Establecimientos ingresados"

// module information
global.M_TITLE = "Módulos"
global.S_TITLE = "Establecimientos ingresados"

// module servicios
global.MS_TITLE = "Módulos"
global.SS_TITLE = "Servicios ingresados"

// module Invoices
global.SI_TITLE = "Facturas"

// module Business
global.SB_TITLE = "Empresa"

// module Users
global.SU_TITLE = "Usuarios"

// module schedules
global.SH_TITLE = "Horarios"